module.exports = __webpack_public_path__ + "img/jieshu.02e94ed3.png";